import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule} from '@angular/common/http';
import { environment } from '../environments/environment';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppNavComponent } from './app-nav/app-nav.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { AntEnvService } from './_services';

import { DataViewerComponent } from './_components/data-viewer/data-viewer.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';

//import { DataDeviceComponent } from './_components/data-device/data-device.component';
import { DataImportComponent } from './_components/data-import/data-import.component';
import { DataRehabComponent } from './_components/data-rehab/data-rehab.component';
import { DataReportComponent } from './_components/data-report/data-report.component';
import { HomeComponent } from './_components/home/home.component';
import { LoginComponent } from './_components/login/login.component';
import { SettingsComponent } from './_components/settings/settings.component';
import { TemplatesComponent } from './_components/templates/templates.component';
import { UsersComponent } from './_components/users/users.component';
import { UsageTrackingComponent } from './_components/usage-tracking/usage-tracking.component';
import { CacheRefreshComponent } from './_components/cache-refresh/cache-refresh.component';
import { LocationSetUpComponent } from './_components/location-setup/location-setup.component';
import { DashboardV02AComponent } from './_components/dashboardV02A/dashboardV02A.component';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardV02AWComponent } from './_components/dashboardV02AW/dashboardV02AW.component';
import { DashboardV02ADComponent } from './_components/dashboardV02AD/dashboardV02AD.component';
import { DashboardV02AMComponent } from './_components/dashboardV02AM/dashboardV02AM.component';
import { DashboardFPComponent } from './_components/dashboardFP/dashboardFP.component';
import { DataPatchComponent } from './_components/data-patch/data-patch.component';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { DashboardCustomComponent } from './_components/dashboardcustom/dashboardcustom.component';
import { DataReportV02Component } from './_components/data-reportV02/data-reportV02.component';
import { AlertsComponent } from './_components/alerts/alerts.component';

@NgModule({
  declarations: [
    AppComponent, AppNavComponent, DashboardV02AComponent, DashboardV02ADComponent, DashboardV02AWComponent, DashboardV02AMComponent,
    DashboardComponent, DashboardCustomComponent, DashboardFPComponent, DataViewerComponent, DataImportComponent, DataRehabComponent, DataReportComponent, DataReportV02Component, DataPatchComponent,
    HomeComponent, LoginComponent, SettingsComponent, TemplatesComponent, UsersComponent, AlertsComponent, UsageTrackingComponent, CacheRefreshComponent, LocationSetUpComponent,
  ],
  imports: [
    BrowserModule, AppRoutingModule, FormsModule, BrowserAnimationsModule, HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase), AngularFireAuthModule,AngularFireMessagingModule,
    OwlDateTimeModule, OwlNativeDateTimeModule, //NgbModule,
    NgxCsvParserModule,
  ],
  providers: [ 
    { provide: APP_INITIALIZER, useFactory: (antEnvSvc: AntEnvService)=> () => antEnvSvc.load().toPromise(), deps: [AntEnvService], multi: true },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
